import * as React from 'react';
import { SensitivityButton } from './SensitivityButton';
export async function getSensitivityButton(informationProtectionServicePromise) {
    const informationProtectionService = await informationProtectionServicePromise;
    return {
        default: (props)=>informationProtectionService ? /*#__PURE__*/ React.createElement(SensitivityButton, {
                informationProtectionService: informationProtectionService,
                ...props
            }) : null
    };
}
